const KEYBOARD_CHARACTERS = {
    nb: {
        symbols: [["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ø", "æ"],
            ["z", "x", "c", "v", "b", "n", "m", "&"]],
        numbers: [["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]]
    },
    sv: {
        symbols: [["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ö", "ä"],
            ["z", "x", "c", "v", "b", "n", "m", "&"]],
        numbers: [["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]]
    },
    en: {
        symbols: [
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
            ["z", "x", "c", "v", "b", "n", "m"]],
        numbers: [["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]]
    },
    fi: {
        symbols: [
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ö", "ä"],
            ["z", "x", "c", "v", "b", "n", "m"]],
        numbers: [["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]]
    },
    de: {
        symbols: [
            ["q", "w", "e", "r", "t", "z", "u", "i", "o", "p", "ü"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ö", "ä"],
            ["y", "x", "c", "v", "b", "n", "m", "&"]
        ],
        numbers: [["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]]
    },
};

export {
    KEYBOARD_CHARACTERS
};
